var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJelbiHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 -7 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32.5C0 41.2327 3.44421 49.1609 9.04834 55.0005L9.00012 55L58.5002 105L107.5 56L107.451 55.9995C113.643 50.082 117.5 41.7415 117.5 32.5C117.5 14.5508 102.949 0 85 0C74.2179 0 64.6622 5.25049 58.75 13.334C52.8378 5.25049 43.2821 0 32.5 0C14.5507 0 0 14.5508 0 32.5Z",
    fill: "#FFF34F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJelbiHeart);
export default __webpack_public_path__ + "static/media/jelbi_heart.4dca458b06f71d0990c9d499c540fdd0.svg";
export { ForwardRef as ReactComponent };